import { useState } from "react";
import { toast } from "sonner";
import { Field, Card, SaveButton, inputCls } from "../ui";
import { adminFetch } from "../adminApi";

export default function PasswordTab() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (next !== confirm) {
      toast.error("Das neue Passwort stimmt nicht mit der Wiederholung überein.");
      return;
    }
    if (next.length < 8) {
      toast.error("Das neue Passwort braucht mindestens 8 Zeichen.");
      return;
    }
    setSaving(true);
    try {
      await adminFetch("/admin/change-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ current_password: current, new_password: next }),
      });
      toast.success("Passwort geändert. Ab sofort gilt das neue Passwort.");
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (e) {
      toast.error(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <Card title="Passwort ändern">
        <Field label="Aktuelles Passwort">
          <input
            data-testid="admin-password-current"
            type="password"
            className={inputCls}
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            autoComplete="current-password"
          />
        </Field>
        <Field label="Neues Passwort (min. 8 Zeichen)">
          <input
            data-testid="admin-password-new"
            type="password"
            className={inputCls}
            value={next}
            onChange={(e) => setNext(e.target.value)}
            autoComplete="new-password"
          />
        </Field>
        <Field label="Neues Passwort wiederholen">
          <input
            data-testid="admin-password-confirm"
            type="password"
            className={inputCls}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            autoComplete="new-password"
          />
        </Field>
        <div>
          <SaveButton onClick={save} saving={saving} testid="admin-save-password" />
        </div>
        <p className="text-xs leading-relaxed text-zinc-600">
          Das Passwort wird verschlüsselt (bcrypt) in der Datenbank gespeichert – nirgendwo im
          Klartext. Nach der Änderung gilt es sofort für alle weiteren Anmeldungen.
        </p>
      </Card>
    </div>
  );
}
